import axios from 'axios';

import { JsonResponse } from 'core/models/response';

export const onCheckInvoice = async (reference: string) => {
	try {
		const response = await axios.get<JsonResponse<{ download_url: string; filename: string }>>(`payment-invoice/qr-download/${reference}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
